import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
  Button,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useSondertagContext } from "../../context/sondertagContext";

import TeacherWorkloadRow from "./TeacherWorkloadRow";
import { useState } from "react";
import sondertagService from "../../services/sondertagService";
import TeacherWorkloadEditDialog from "./TeacherWorkloadEditDialog";

export default function SondertagPensenDialog({ open, onClose }) {
  const { isMobile } = useAppContext();
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  const { teacherWorkloads, selectedSchoolyear } = useSondertagContext();

  const teachers = Object.entries(teacherWorkloads || {})
    .map(([abbreviation, teacher]) => ({
      abbreviation,
      ...teacher,
    }))
    .sort((a, b) => a.abbreviation.localeCompare(b.abbreviation));

  const handleAdd = () => {
    setSelectedTeacher(null);
    setEditDialogOpen(true);
  };

  const handleEdit = (teacher) => {
    setSelectedTeacher(teacher);
    setEditDialogOpen(true);
  };

  const handleDelete = async (teacher) => {
    await sondertagService.deleteTeacherStat(
      teacher.abbreviation,
      selectedSchoolyear.id,
    );

    // reload
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile ? 275 : 550,
          maxWidth: isMobile ? "95vw" : "110vw",
        },
      }}
    >
      <DialogTitle>Unterrichtspensen {selectedSchoolyear?.label}</DialogTitle>

      <DialogContent dividers>
        <Typography variant="caption" sx={{ opacity: 0.7 }}>
          Lehrpersonen-Pensen für die Berechnung der Sondertage-Einsätze
        </Typography>

        <Divider sx={{ mt: 1, mb: 2 }} />

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          fullWidth
          onClick={handleAdd}
          sx={{ mb: 2 }}
        >
          Lehrperson hinzufügen
        </Button>

        <Box>
          {teachers.map((teacher) => (
            <TeacherWorkloadRow
              key={teacher.abbreviation}
              teacher={teacher}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}
        </Box>
        <TeacherWorkloadEditDialog
          open={editDialogOpen}
          teacher={selectedTeacher}
          schoolyearId={selectedSchoolyear.id}
          onClose={() => {
            setEditDialogOpen(false);
            setSelectedTeacher(null);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
